import moment from 'moment';
import { getData, postData } from 'src/api/http.service';
import {
  getDataFromSessionStorage,
  handleApiError,
  handleApiSuccess,
} from 'src/utils/general.utils';
import { getAPIEndpoints } from 'src/utils';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';

const studentManagementActions = {
  STUDENT_DETAILS_LIST_SUCCESS: '[API] : Get students details action.',
  STUDENT_LIST_SUCCESS: '[API] : Get students list action.',
  STUDENT_SUBSCRIPTIONS_SUCCESS: '[API] : Get students subscription details action.',
  STUDENT_ADDONS_SUCCESS: '[API] : Get students subscribed addons details action.',
  STUDENT_INVOICES_SUCCESS: '[API] : Get students invoiceslist action.',
  STUDENT_EMAIL_VERIFY_SUCCESS: '[API] : Verify student email action.',
};

/*
    Plain Actions
*/

function StudentDetailsSuccessAction(payload) {
  return {
    type: studentManagementActions.STUDENT_DETAILS_LIST_SUCCESS,
    payload,
  };
}
function StudentListSuccessAction(payload) {
  return {
    type: studentManagementActions.STUDENT_LIST_SUCCESS,
    payload,
  };
}

function StudentSubscriptionsSuccessAction(payload) {
  return {
    type: studentManagementActions.STUDENT_SUBSCRIPTIONS_SUCCESS,
    payload,
  };
}

function StudentInvoicesSuccessAction(payload) {
  return {
    type: studentManagementActions.STUDENT_INVOICES_SUCCESS,
    payload,
  };
}

function StudentSubscribedAddonsSuccessAction(payload) {
  return {
    type: studentManagementActions.STUDENT_ADDONS_SUCCESS,
    payload,
  };
}

function StudentEmailVerifySuccessAction(payload) {
  return {
    type: studentManagementActions.STUDENT_SUBSCRIPTIONS_SUCCESS,
    payload,
  };
}
/*
    Async Actions
*/

function GetStudentListAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(StudentListSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      dispatch(StudentListSuccessAction({ data: { content: [], totalElements: 0 } }));
      return false;
    }
  };
}

function GetStudentDetailsAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(StudentDetailsSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      dispatch(StudentDetailsSuccessAction({ data: {} }));
      return false;
    }
  };
}

function GetStudentSubscriptionsListAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(StudentSubscriptionsSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(StudentSubscriptionsSuccessAction([]));
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}
function GetStudentInvoicesListAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(StudentInvoicesSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(StudentInvoicesSuccessAction([]));
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export const GetStudentSubscribedAddonsList = ({ studentId }) => {
  return async dispatch => {
    try {
      const url = `${getAPIEndpoints().getSubscribedAddonsList}/${studentId}`;
      dispatch(ApiCallInProgress());
      const response = await getData(url);
      dispatch(StudentSubscribedAddonsSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response)));
      return true;
    } catch (err) {
      dispatch(StudentSubscribedAddonsSuccessAction([]));
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return false;
    }
  };
};

function VerifyStudentEmailAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(url, body, headers);
      dispatch(StudentEmailVerifySuccessAction(response));
      setTimeout(() => {
        dispatch(
          GetStudentDetailsAction(
            `${getAPIEndpoints().getStudentInfo}?mobileNumber=${body.mobile}`,
            headers
          )
        );
      }, 2000);
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}
function GetInvoiceAction(url, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await getData(url);
      let formattedResponse = handleApiSuccess(response, metaData);
      dispatch(ApiCallSuccessAction(formattedResponse));
      //dispatch(GetInvoiceSuccessAction(response.data));
      return response.data;
    } catch (err) {
      let formattedError = handleApiError(err);
      dispatch(ApiCallFailedAction(formattedError));
      return false;
    }
  };
}

const GetPrimaryDevices = studentId => async dispatch => {
  if (!studentId) return false;

  try {
    dispatch(ApiCallInProgress());
    const url = getAPIEndpoints().fetchPrimaryDevices + `/${studentId}`;
    const response = await getData(url);
    return response.data;
  } catch (err) {
    return false;
  }
};

const GetLastAccessedDevicesInfo = ({
  fromDate = moment()
    .subtract(6, 'months')
    .format('YYYY-MM-DD'),
  page = 0,
  size = 5000,
  userId,
}) => async dispatch => {
  try {
    if (!userId) return false;

    dispatch(ApiCallInProgress());
    const url = getAPIEndpoints().retriveLastAccessedDevicesInfo;
    const payload = {
      userId,
      fromDate,
      page,
      size,
    };
    const response = await postData(url, payload);
    dispatch(ApiCallSuccessAction(handleApiSuccess(response)));
    return response.data;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
    return false;
  }
};

const RequestDeviceModification = ({ deviceId, deviceType }, reason) => async (
  dispatch,
  getState
) => {
  try {
    const userInfo = getDataFromSessionStorage('userInfo');
    const { studentDetails } = getState().studentManage;
    const payload = {
      userId: studentDetails.studentId,
      deviceId,
      deviceType,
      reason,
      requestedBy: userInfo.userName || userInfo.email || userInfo.mobile, // Full Name or Email or Phone
    };

    if (!payload.requestedBy) return false;
    dispatch(ApiCallInProgress());
    const url = getAPIEndpoints().resetDevice;
    const response = await postData(url, payload);
    dispatch(ApiCallSuccessAction(handleApiSuccess(response)));
    dispatch(ApiCallSuccessAction({ message: 'Change request successfully submitted' }));
    return response.data;
  } catch (err) {
    dispatch(ApiCallFailedAction({ message: 'Change request submission failed' }));
    return false;
  }
};

export {
  studentManagementActions,
  GetStudentListAction,
  GetStudentDetailsAction,
  GetStudentSubscriptionsListAction,
  GetStudentInvoicesListAction,
  VerifyStudentEmailAction,
  GetInvoiceAction,
  RequestDeviceModification,
  GetPrimaryDevices,
  GetLastAccessedDevicesInfo,
};
